import { InjectionToken, Inject, PLATFORM_ID, Injectable, EventEmitter, Input, Output, ViewChild, ElementRef, Component, NgModule } from '@angular/core';
import { __decorate, __param, __metadata } from 'tslib';
import { isPlatformBrowser, isPlatformServer, CommonModule } from '@angular/common';
import { BehaviorSubject, ReplaySubject, from, Subject, combineLatest } from 'rxjs';
import { take, filter, map, publishLast, refCount, switchMap } from 'rxjs/operators';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common';

const _c0 = ["request"];
const _c1 = ["card"];
function StripeCardComponent_div_2_Template(rf, ctx) { if (rf & 1) {
    ɵngcc0.ɵɵelement(0, "div");
} if (rf & 2) {
    const type_r2 = ctx.$implicit;
    ɵngcc0.ɵɵclassMap(type_r2);
} }
function isSourceData(sourceData) {
    return 'type' in sourceData;
}

const STRIPE_PUBLISHABLE_KEY = new InjectionToken('Stripe Publishable Key');
const STRIPE_OPTIONS = new InjectionToken('Stripe Options');

function isBankAccount(account) {
    return account === 'bank_account';
}
function isBankAccountData(bankAccountData) {
    return ('country' in bankAccountData &&
        'currency' in bankAccountData &&
        'routing_number' in bankAccountData &&
        'account_number' in bankAccountData &&
        'account_holder_name' in bankAccountData &&
        'account_holder_type' in bankAccountData &&
        (bankAccountData.account_holder_type === 'individual' || bankAccountData.account_holder_type === 'company'));
}
function isPii(pii) {
    return pii === 'pii';
}
function isPiiData(piiData) {
    return 'personal_id_number' in piiData;
}

let PlatformService = class PlatformService {
    constructor(platformId) {
        this.platformId = platformId;
    }
    get isBrowser() {
        return isPlatformBrowser(this.platformId);
    }
    get isServer() {
        return isPlatformServer(this.platformId);
    }
};
PlatformService.ɵfac = function PlatformService_Factory(t) { return new (t || PlatformService)(ɵngcc0.ɵɵinject(PLATFORM_ID)); };
PlatformService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: PlatformService, factory: function (t) { return PlatformService.ɵfac(t); } });
PlatformService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
PlatformService = __decorate([ __param(0, Inject(PLATFORM_ID)),
    __metadata("design:paramtypes", [Object])
], PlatformService);

let DocumentRef = class DocumentRef {
    constructor(_platform) {
        this._platform = _platform;
    }
    getNativeDocument() {
        if (this._platform.isBrowser) {
            return document;
        }
        return {};
    }
};
DocumentRef.ɵfac = function DocumentRef_Factory(t) { return new (t || DocumentRef)(ɵngcc0.ɵɵinject(PlatformService)); };
DocumentRef.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: DocumentRef, factory: function (t) { return DocumentRef.ɵfac(t); } });
DocumentRef.ctorParameters = () => [
    { type: PlatformService }
];
DocumentRef = __decorate([ __metadata("design:paramtypes", [PlatformService])
], DocumentRef);

let WindowRef = class WindowRef {
    constructor(_platform) {
        this._platform = _platform;
    }
    getNativeWindow() {
        if (this._platform.isBrowser) {
            return window;
        }
        return {};
    }
};
WindowRef.ɵfac = function WindowRef_Factory(t) { return new (t || WindowRef)(ɵngcc0.ɵɵinject(PlatformService)); };
WindowRef.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: WindowRef, factory: function (t) { return WindowRef.ɵfac(t); } });
WindowRef.ctorParameters = () => [
    { type: PlatformService }
];
WindowRef = __decorate([ __metadata("design:paramtypes", [PlatformService])
], WindowRef);

let LazyStripeAPILoader = class LazyStripeAPILoader {
    constructor(window, document, _platform) {
        this.window = window;
        this.document = document;
        this._platform = _platform;
        this.status = new BehaviorSubject({
            error: false,
            loaded: false,
            loading: false
        });
    }
    asStream() {
        this.load();
        return this.status.asObservable();
    }
    isReady() {
        return this.status.getValue().loaded;
    }
    load() {
        if (this._platform.isServer) {
            return;
        }
        if (this.window.getNativeWindow().hasOwnProperty('Stripe')) {
            this.status.next({
                error: false,
                loaded: true,
                loading: false
            });
        }
        else {
            if (!this.status.getValue().loaded && !this.status.getValue().loading) {
                this.status.next(Object.assign({}, this.status.getValue(), { loading: true }));
                const script = this.document
                    .getNativeDocument()
                    .createElement('script');
                script.type = 'text/javascript';
                script.async = true;
                script.defer = true;
                script.src = 'https://js.stripe.com/v3/';
                script.onload = () => {
                    this.status.next({
                        error: false,
                        loaded: true,
                        loading: false
                    });
                };
                script.onerror = () => {
                    this.status.next({
                        error: true,
                        loaded: false,
                        loading: false
                    });
                };
                this.document.getNativeDocument().body.appendChild(script);
            }
        }
    }
};
LazyStripeAPILoader.ɵfac = function LazyStripeAPILoader_Factory(t) { return new (t || LazyStripeAPILoader)(ɵngcc0.ɵɵinject(WindowRef), ɵngcc0.ɵɵinject(DocumentRef), ɵngcc0.ɵɵinject(PlatformService)); };
LazyStripeAPILoader.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: LazyStripeAPILoader, factory: function (t) { return LazyStripeAPILoader.ɵfac(t); } });
LazyStripeAPILoader.ctorParameters = () => [
    { type: WindowRef },
    { type: DocumentRef },
    { type: PlatformService }
];
LazyStripeAPILoader = __decorate([ __metadata("design:paramtypes", [WindowRef,
        DocumentRef,
        PlatformService])
], LazyStripeAPILoader);

let StripeService = class StripeService {
    constructor(key, options, loader, window, _platform) {
        this.key = key;
        this.options = options;
        this.loader = loader;
        this.window = window;
        this._platform = _platform;
        this.stripeChanged$ = new ReplaySubject();
        this.stripe = {};
        this.changeKey(this.key, this.options)
            .pipe(take(1))
            .subscribe(() => { });
    }
    changeKey(key, options) {
        const obs = this.loader.asStream().pipe(filter((status) => status.loaded === true), map(() => {
            if (!this.window.getNativeWindow()) {
                return;
            }
            const Stripe = this.window.getNativeWindow().Stripe;
            if (key) {
                this.stripe = options ? Stripe(key, options) : Stripe(key);
                this.stripeChanged$.next(this.stripe);
            }
            return this.stripe;
        }), publishLast(), refCount());
        obs.subscribe();
        return obs;
    }
    elements(options) {
        return this.stripeChanged$.pipe(map(() => this.stripe.elements(options)));
    }
    createToken(a, b) {
        if (isBankAccount(a) && isBankAccountData(b)) {
            return from(this.stripe.createToken(a, b));
        }
        else if (isPii(a) && isPiiData(b)) {
            return from(this.stripe.createToken(a, b));
        }
        else {
            return from(this.stripe.createToken(a, b));
        }
    }
    paymentRequest(options) {
        return this.stripeChanged$.pipe(map(() => this.stripe.paymentRequest(options)));
    }
    handleCardSetup(clientSecret, element, cardSetupOptions) {
        return from(this.stripe.handleCardSetup(clientSecret, element, cardSetupOptions));
    }
    handleCardPayment(clientSecret, element, cardSetupOptions) {
        return from(this.stripe.handleCardPayment(clientSecret, element, cardSetupOptions));
    }
    handleCardAction(clientSecret) {
        return from(this.stripe.handleCardAction(clientSecret));
    }
    confirmPaymentIntent(clientSecret, element, intentOptions) {
        return from(this.stripe.confirmPaymentIntent(clientSecret, element, intentOptions));
    }
    confirmCardPayment(clientSecret, data, options) {
        return from(this.stripe.confirmCardPayment(clientSecret, data, options));
    }
    retrievePaymentIntent(clientSecret) {
        return from(this.stripe.retrievePaymentIntent(clientSecret));
    }
    retrieveSetupIntent(clientSecret) {
        return from(this.stripe.retrieveSetupIntent(clientSecret));
    }
    confirmSetupIntent(clientSecret, element, intentOptions) {
        return from(this.stripe.confirmSetupIntent(clientSecret, element, intentOptions));
    }
    createSource(a, b) {
        if (isSourceData(a)) {
            return from(this.stripe.createSource(a));
        }
        return from(this.stripe.createSource(a, b));
    }
    retrieveSource(source) {
        return from(this.stripe.retrieveSource(source));
    }
    createPaymentMethod(paymentMethod) {
        return from(this.stripe.createPaymentMethod(paymentMethod));
    }
};
StripeService.ɵfac = function StripeService_Factory(t) { return new (t || StripeService)(ɵngcc0.ɵɵinject(STRIPE_PUBLISHABLE_KEY), ɵngcc0.ɵɵinject(STRIPE_OPTIONS), ɵngcc0.ɵɵinject(LazyStripeAPILoader), ɵngcc0.ɵɵinject(WindowRef), ɵngcc0.ɵɵinject(PlatformService)); };
StripeService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: StripeService, factory: function (t) { return StripeService.ɵfac(t); } });
StripeService.ctorParameters = () => [
    { type: String, decorators: [{ type: Inject, args: [STRIPE_PUBLISHABLE_KEY,] }] },
    { type: undefined, decorators: [{ type: Inject, args: [STRIPE_OPTIONS,] }] },
    { type: LazyStripeAPILoader },
    { type: WindowRef },
    { type: PlatformService }
];
StripeService = __decorate([ __param(0, Inject(STRIPE_PUBLISHABLE_KEY)),
    __param(1, Inject(STRIPE_OPTIONS)),
    __metadata("design:paramtypes", [String, Object, LazyStripeAPILoader,
        WindowRef,
        PlatformService])
], StripeService);

let PaymentRequestComponent = class PaymentRequestComponent {
    constructor(stripeService) {
        this.stripeService = stripeService;
        this.change = new EventEmitter();
        this.shippingAddressChange = new EventEmitter();
        this.shippingOptionChange = new EventEmitter();
        this.cancel = new EventEmitter();
        this.hide = false;
        this.styles$ = new BehaviorSubject({});
        this.options$ = new ReplaySubject();
        this.elementsOptions$ = new BehaviorSubject({});
        this.complete$ = new Subject();
        this._attached = false;
        this._opened = false;
    }
    set options(optionsIn) {
        this.options$.next(optionsIn);
    }
    set elementsOptions(optionsIn) {
        this.elementsOptions$.next(optionsIn);
    }
    set styles(optionsIn) {
        this.styles$.next(optionsIn);
    }
    set complete(success) {
        this.complete$.next(success);
    }
    ngOnInit() {
        this.elements$ = this.elementsOptions$.asObservable().pipe(switchMap(options => {
            return this.stripeService.elements(options);
        }));
        this.request$ = this.options$.asObservable().pipe(switchMap(options => {
            return this.stripeService.paymentRequest(options);
        }));
        this.complete$.subscribe(complete => {
            if (this.lastEvent) {
                if (complete) {
                    this.lastEvent.complete('success');
                }
                else {
                    this.lastEvent.complete('fail');
                }
            }
        });
    }
    ngAfterViewInit() {
        combineLatest(this.request$, this.elements$, this.options$, this.styles$).subscribe(([paymentRequest, elements, options, styles]) => {
            if (this.requestButton && !this._attached) {
                this._paymentRequest = paymentRequest;
                this._attached = true;
                const element = elements.create('paymentRequestButton', {
                    paymentRequest,
                    style: {
                        paymentRequestButton: Object.assign({}, styles)
                    }
                });
                this.hide = false;
                paymentRequest.canMakePayment().then(result => {
                    if (result) {
                        element.mount(this.requestButton.nativeElement);
                    }
                    else {
                        this.hide = true;
                    }
                });
                paymentRequest.on('shippingaddresschange', event => {
                    this.shippingAddressChange.emit(event);
                });
                paymentRequest.on('shippingoptionchange', event => {
                    this.shippingOptionChange.emit(event);
                });
                paymentRequest.on('token', event => {
                    this.change.emit(event);
                    this._opened = false;
                });
                paymentRequest.on('paymentmethod', event => {
                    this.change.emit(event);
                });
                paymentRequest.on('source', event => {
                    this.change.emit(event);
                });
                paymentRequest.on('cancel', event => {
                    this.cancel.emit(event);
                    this._opened = false;
                });
                paymentRequest.on('click', () => {
                    this._opened = true;
                });
            }
            else if (this._attached && !this._opened) {
                this._paymentRequest.update({
                    currency: options.currency,
                    total: options.total,
                    displayItems: options.displayItems,
                    shippingOptions: options.shippingOptions
                });
            }
        });
    }
};
PaymentRequestComponent.ɵfac = function PaymentRequestComponent_Factory(t) { return new (t || PaymentRequestComponent)(ɵngcc0.ɵɵdirectiveInject(StripeService)); };
PaymentRequestComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: PaymentRequestComponent, selectors: [["ngx-payment-request"]], viewQuery: function PaymentRequestComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c0, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.requestButton = _t.first);
    } }, inputs: { options: "options", elementsOptions: "elementsOptions", styles: "styles", complete: "complete" }, outputs: { change: "change", shippingAddressChange: "shippingAddressChange", shippingOptionChange: "shippingOptionChange", cancel: "cancel" }, decls: 2, vars: 2, consts: [["request", ""]], template: function PaymentRequestComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelement(0, "div", null, 0);
    } if (rf & 2) {
        ɵngcc0.ɵɵstyleProp("display-none", ctx.hide);
    } }, encapsulation: 2 });
PaymentRequestComponent.ctorParameters = () => [
    { type: StripeService }
];
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PaymentRequestComponent.prototype, "options", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PaymentRequestComponent.prototype, "elementsOptions", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], PaymentRequestComponent.prototype, "styles", null);
__decorate([
    Input(),
    __metadata("design:type", Boolean),
    __metadata("design:paramtypes", [Boolean])
], PaymentRequestComponent.prototype, "complete", null);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PaymentRequestComponent.prototype, "change", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PaymentRequestComponent.prototype, "shippingAddressChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PaymentRequestComponent.prototype, "shippingOptionChange", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], PaymentRequestComponent.prototype, "cancel", void 0);
__decorate([
    ViewChild('request', { static: false }),
    __metadata("design:type", ElementRef)
], PaymentRequestComponent.prototype, "requestButton", void 0);
PaymentRequestComponent = __decorate([ __metadata("design:paramtypes", [StripeService])
], PaymentRequestComponent);

let StripeCardComponent = class StripeCardComponent {
    constructor(stripeService) {
        this.stripeService = stripeService;
        this.change = new EventEmitter();
        this.complete = new EventEmitter();
        this.error = new EventEmitter();
        this.elementTypes = ['card'];
        this.options$ = new BehaviorSubject({});
        this.elementsOptions$ = new BehaviorSubject({});
    }
    set options(optionsIn) {
        this.options$.next(optionsIn);
    }
    set elementsOptions(optionsIn) {
        this.elementsOptions$.next(optionsIn);
    }
    ngAfterViewInit() {
        const elements$ = this.elementsOptions$.asObservable().pipe(switchMap(options => {
            if (Object.keys(options).length > 0) {
                return this.stripeService.elements(options);
            }
            return this.stripeService.elements();
        }));
        let complete = {};
        combineLatest(elements$, this.options$.asObservable().pipe(filter(options => Boolean(options)))).subscribe(([elements, options]) => {
            this.elements = [];
            if (this.card) {
                for (const type of this.elementTypes) {
                    const element = elements.create(type, options);
                    complete = Object.assign({}, complete, { [type]: element });
                    if (['card', 'cardNumber'].indexOf(type) !== -1) {
                        this.cardElement = element;
                    }
                    const mountTo = this.card.nativeElement.querySelector(`.${type}`);
                    element.mount(mountTo);
                    element.on('change', changedCard => {
                        let isComplete = changedCard.complete;
                        for (const key in complete) {
                            if (complete) {
                                const value = complete[key];
                                if (key !== changedCard.elementType && !value._complete) {
                                    isComplete = false;
                                }
                            }
                        }
                        this.change.emit({
                            card: changedCard,
                            elements: this.elements,
                            type: changedCard.elementType,
                            complete: isComplete,
                            element: element
                        });
                        if (isComplete) {
                            this.complete.emit({
                                card: changedCard,
                                elements: this.elements,
                                type: changedCard.elementType,
                                complete: isComplete,
                                element: element
                            });
                        }
                        if (changedCard.error) {
                            this.error.emit(changedCard.error);
                        }
                    });
                    this.elements = [...this.elements, element];
                }
            }
        });
    }
    getCard() {
        return this.cardElement;
    }
};
StripeCardComponent.ɵfac = function StripeCardComponent_Factory(t) { return new (t || StripeCardComponent)(ɵngcc0.ɵɵdirectiveInject(StripeService)); };
StripeCardComponent.ɵcmp = /*@__PURE__*/ ɵngcc0.ɵɵdefineComponent({ type: StripeCardComponent, selectors: [["ngx-stripe-card"]], viewQuery: function StripeCardComponent_Query(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵviewQuery(_c1, 5);
    } if (rf & 2) {
        let _t;
        ɵngcc0.ɵɵqueryRefresh(_t = ɵngcc0.ɵɵloadQuery()) && (ctx.card = _t.first);
    } }, inputs: { elementTypes: "elementTypes", options: "options", elementsOptions: "elementsOptions" }, outputs: { change: "change", complete: "complete", error: "error" }, decls: 3, vars: 1, consts: [[1, "field"], ["card", ""], [3, "class", 4, "ngFor", "ngForOf"]], template: function StripeCardComponent_Template(rf, ctx) { if (rf & 1) {
        ɵngcc0.ɵɵelementStart(0, "div", 0, 1);
        ɵngcc0.ɵɵtemplate(2, StripeCardComponent_div_2_Template, 1, 2, "div", 2);
        ɵngcc0.ɵɵelementEnd();
    } if (rf & 2) {
        ɵngcc0.ɵɵadvance(2);
        ɵngcc0.ɵɵproperty("ngForOf", ctx.elementTypes);
    } }, dependencies: [ɵngcc1.NgForOf], encapsulation: 2 });
StripeCardComponent.ctorParameters = () => [
    { type: StripeService }
];
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], StripeCardComponent.prototype, "options", null);
__decorate([
    Input(),
    __metadata("design:type", Object),
    __metadata("design:paramtypes", [Object])
], StripeCardComponent.prototype, "elementsOptions", null);
__decorate([
    Output(),
    __metadata("design:type", Object)
], StripeCardComponent.prototype, "change", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], StripeCardComponent.prototype, "complete", void 0);
__decorate([
    Output(),
    __metadata("design:type", Object)
], StripeCardComponent.prototype, "error", void 0);
__decorate([
    Input(),
    __metadata("design:type", Array)
], StripeCardComponent.prototype, "elementTypes", void 0);
__decorate([
    ViewChild('card', { static: false }),
    __metadata("design:type", ElementRef)
], StripeCardComponent.prototype, "card", void 0);
StripeCardComponent = __decorate([ __metadata("design:paramtypes", [StripeService])
], StripeCardComponent);

var NgxStripeModule_1;
let NgxStripeModule = NgxStripeModule_1 = class NgxStripeModule {
    static forRoot(publishableKey, options) {
        return {
            ngModule: NgxStripeModule_1,
            providers: [
                LazyStripeAPILoader,
                StripeService,
                PlatformService,
                WindowRef,
                DocumentRef,
                {
                    provide: STRIPE_PUBLISHABLE_KEY,
                    useValue: publishableKey
                },
                {
                    provide: STRIPE_OPTIONS,
                    useValue: options
                }
            ]
        };
    }
};
NgxStripeModule.ɵfac = function NgxStripeModule_Factory(t) { return new (t || NgxStripeModule)(); };
NgxStripeModule.ɵmod = /*@__PURE__*/ ɵngcc0.ɵɵdefineNgModule({ type: NgxStripeModule });
NgxStripeModule.ɵinj = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjector({ imports: [CommonModule] });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PlatformService, [{
        type: Injectable
    }], function () { return [{ type: undefined, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(DocumentRef, [{
        type: Injectable
    }], function () { return [{ type: PlatformService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WindowRef, [{
        type: Injectable
    }], function () { return [{ type: PlatformService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LazyStripeAPILoader, [{
        type: Injectable
    }], function () { return [{ type: WindowRef }, { type: DocumentRef }, { type: PlatformService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StripeService, [{
        type: Injectable
    }], function () { return [{ type: String, decorators: [{
                type: Inject,
                args: [STRIPE_PUBLISHABLE_KEY]
            }] }, { type: undefined, decorators: [{
                type: Inject,
                args: [STRIPE_OPTIONS]
            }] }, { type: LazyStripeAPILoader }, { type: WindowRef }, { type: PlatformService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PaymentRequestComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-payment-request',
                template: '<div #request [style.display-none]="hide"></div>'
            }]
    }], function () { return [{ type: StripeService }]; }, { change: [{
            type: Output
        }], shippingAddressChange: [{
            type: Output
        }], shippingOptionChange: [{
            type: Output
        }], cancel: [{
            type: Output
        }], options: [{
            type: Input
        }], elementsOptions: [{
            type: Input
        }], styles: [{
            type: Input
        }], complete: [{
            type: Input
        }], requestButton: [{
            type: ViewChild,
            args: ['request', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(StripeCardComponent, [{
        type: Component,
        args: [{
                selector: 'ngx-stripe-card',
                template: `
    <div class="field" #card>
      <div [class]="type" *ngFor="let type of elementTypes"></div>
    </div>
  `
            }]
    }], function () { return [{ type: StripeService }]; }, { change: [{
            type: Output
        }], complete: [{
            type: Output
        }], error: [{
            type: Output
        }], elementTypes: [{
            type: Input
        }], options: [{
            type: Input
        }], elementsOptions: [{
            type: Input
        }], card: [{
            type: ViewChild,
            args: ['card', { static: false }]
        }] }); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NgxStripeModule, [{
        type: NgModule,
        args: [{
                imports: [CommonModule],
                declarations: [StripeCardComponent, PaymentRequestComponent],
                exports: [StripeCardComponent, PaymentRequestComponent]
            }]
    }], null, null); })();
(function () { (typeof ngJitMode === "undefined" || ngJitMode) && ɵngcc0.ɵɵsetNgModuleScope(NgxStripeModule, { declarations: function () { return [StripeCardComponent, PaymentRequestComponent]; }, imports: function () { return [CommonModule]; }, exports: function () { return [StripeCardComponent, PaymentRequestComponent]; } }); })();

/*
 * Public API Surface of ngx-stripe
 */

/**
 * Generated bundle index. Do not edit.
 */

export { DocumentRef, LazyStripeAPILoader, NgxStripeModule, PlatformService, STRIPE_OPTIONS, STRIPE_PUBLISHABLE_KEY, StripeCardComponent, StripeService, WindowRef, isBankAccount, isBankAccountData, isPii, isPiiData, isSourceData, PaymentRequestComponent as ɵa };

